/*
 * File: getPillBoxDetail.tsx
 * Project: meki
 * File Created: Tuesday, 25th January 2022 3:29:05 pm
 * Author: Luis Aparicio (luis@inventures.cl)
 * -----
 * Last Modified: Tuesday, 26th July 2022 4:06:16 pm
 * Modified By: Blanca Munizaga (blanca@inventures.cl)
 * -----
 * Copyright 2019 - 2022 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */

import { gql } from '@apollo/client';
import { PillBoxDetail } from '@interfaces';
import { ResolverParams } from '@queries/queries.interfaces';

export const getPillBoxDetail = () => gql`
  query GetPillBoxDetail($params: GetPillBoxDetailParams!) {
    pillBoxDetail(params: $params) {
      id
      lastMovementBalance
      userStock
      frequency
      remainingBalanceDays
      lastOrderDate
      speedConsumption
      consumptionUnit
      hidden
      product {
        id
        uuid
        name
        format
        slug
        unit
        concentration
        activePrinciple
        availability {
          status
        }
        laboratory
        prescriptionType
        price
        isMedicine
        thumbnailUrl
      }
    }
  }
`;

export type GetPillBoxDetailQueryParams = ResolverParams<{
  productSlug: string;
}>;
export type GetPillBoxDetailResponseQuery = { pillBoxDetail: PillBoxDetail };
